// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.srprs-dropdown {
  box-shadow: 0 0 12px 0 rgba(34, 34, 34, 0.15);
  color: #222;
  background-color: #fff;
  margin-bottom: 12px;
}
.srprs-dropdown.is-complete header .srprs-icon:first-child circle {
  fill: #7ed321;
}
.srprs-dropdown.is-warning header .srprs-icon:first-child circle {
  fill: #eb3a3c;
}
.is-condensed .srprs-dropdown {
  position: relative;
  margin-bottom: 0;
}
.is-condensed .srprs-dropdown > input:checked ~ div {
  margin-bottom: 10px;
}
.is-condensed .srprs-dropdown:nth-child(1) {
  z-index: 9;
}
.is-condensed .srprs-dropdown:nth-child(2) {
  z-index: 8;
}
.is-condensed .srprs-dropdown:nth-child(3) {
  z-index: 7;
}
.is-condensed .srprs-dropdown:nth-child(4) {
  z-index: 6;
}
.is-condensed .srprs-dropdown:nth-child(5) {
  z-index: 5;
}
.is-condensed .srprs-dropdown:nth-child(6) {
  z-index: 4;
}
.is-condensed .srprs-dropdown:nth-child(7) {
  z-index: 3;
}
.is-condensed .srprs-dropdown:nth-child(8) {
  z-index: 2;
}
.is-condensed .srprs-dropdown:nth-child(9) {
  z-index: 1;
}
.srprs-dropdown > input[type=radio],
.srprs-dropdown > input[type=checkbox] {
  position: absolute;
  opacity: 0;
  z-index: -1;
}
.srprs-dropdown header {
  width: 100%;
  position: relative;
  line-height: 0;
  border-width: 0 0 1px;
  border-style: solid;
  border-color: #fff;
}
.srprs-dropdown header label {
  width: 100%;
  display: inline-block;
  cursor: pointer;
  font-size: 1.125rem;
  padding-top: 18px;
  padding-right: 50px;
  padding-bottom: 18px;
  padding-left: 20px;
  text-align: left;
  text-transform: uppercase;
  line-height: 1.625rem;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  margin-left: 0px;
}
.srprs-dropdown header label strong {
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-weight: bold;
}
.srprs-dropdown header .srprs-icon {
  display: inline-block;
  position: absolute;
  top: 50%;
  bottom: auto;
  margin-left: 20px;
  margin-right: 20px;
}
.srprs-dropdown header .srprs-icon svg {
  width: 100%;
  height: auto;
}
.srprs-dropdown header .srprs-icon:first-child {
  width: 22px;
  height: 22px;
  left: 0;
  margin-top: -11px;
}
.srprs-dropdown header .srprs-icon:first-child + label {
  padding-left: 54px;
}
.srprs-dropdown header .srprs-icon:last-child {
  width: 12px;
  height: 12px;
  right: 0;
  margin-top: -6px;
  line-height: 16px;
}
.srprs-dropdown header .srprs-icon#payment-ideal {
  width: 37px;
  margin-top: -9px;
}
.srprs-dropdown header .srprs-icon#payment-mastercard {
  width: 48px;
  height: 28px;
}
.srprs-dropdown header .srprs-icon#payment-visa {
  width: 46px;
  margin-top: -13px;
}
.srprs-dropdown header .srprs-icon#payment-paypal {
  width: 27px;
  margin-top: -3px;
}
.srprs-dropdown header .srprs-icon#payment-klarna {
  width: 46px;
  margin-top: -3px;
}
.srprs-dropdown header .srprs-icon#payment-bancontact {
  width: 50px;
  margin-top: -15px;
}
.srprs-dropdown header .srprs-icon:first-child[id^=payment] {
  top: 50%;
  margin-left: 50px;
  transform: translate(-50%, -50%);
}
.srprs-dropdown header .srprs-icon:first-child[id^=payment] + label {
  padding-left: 100px;
}
.srprs-dropdown > div {
  max-height: 0;
  overflow-y: hidden;
}
.srprs-dropdown > div > div {
  padding-top: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
}
.srprs-dropdown > div > footer {
  width: 100%;
  background-color: #f4f4f4;
  padding-top: 10px;
  padding-right: 20px;
  padding-bottom: 10px;
  padding-left: 20px;
}
.srprs-dropdown > div > footer::after {
  clear: both;
  content: "";
  display: table;
}
.srprs-dropdown > div > footer .srprs-button {
  text-transform: uppercase;
}
.srprs-dropdown > div > footer .srprs-button:first-child:last-child {
  float: right;
}
.srprs-dropdown > div > footer:empty {
  display: none;
}
.srprs-dropdown > header label,
.srprs-dropdown > header .srprs-icon:last-child,
.srprs-dropdown > div {
  transition: all 200ms ease 0s;
}
.srprs-dropdown > input:not(:checked) ~ header label:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
}
.srprs-dropdown > input:checked ~ header {
  border-color: #e7e7e7;
}
.srprs-dropdown > input:checked ~ header .srprs-icon:last-child {
  transform: rotate(-180deg);
}
.srprs-dropdown > input:checked ~ div {
  max-height: 1400px;
  margin-bottom: 24px;
  overflow-y: visible;
}
.srprs-dropdown .footer-temp {
  position: relative;
  display: flex;
  align-items: center;
  left: -20px;
  bottom: -20px;
  width: calc(100% + 40px);
  height: 80px;
  min-height: 80px;
  padding-right: 20px;
  padding-left: 20px;
  background-color: #e7e7e7;
}
.srprs-dropdown .footer-temp span {
  margin-left: auto;
}
.srprs-dropdown .footer-temp span + .srprs-button {
  margin-left: 15px;
}
.srprs-dropdown .footer-temp .srprs-button {
  margin-left: auto;
}

@media screen and (min-width: 768px) {
  .srprs-dropdown > header label {
    font-size: 16px;
    padding-top: 28px;
    padding-right: 60px;
    padding-bottom: 28px;
    padding-left: 30px;
  }
  .srprs-dropdown > header .srprs-icon {
    margin-right: 30px;
    margin-left: 30px;
  }
  .srprs-dropdown > header .srprs-icon:first-child + label {
    padding-left: 70px;
  }
  .srprs-dropdown > div > div {
    padding-top: 30px;
    padding-right: 30px;
    padding-bottom: 30px;
    padding-left: 30px;
  }
  .srprs-dropdown > div > footer {
    padding-top: 14px;
    padding-right: 30px;
    padding-bottom: 14px;
    padding-left: 30px;
  }
  .srprs-dropdown .footer-temp {
    left: -30px;
    bottom: -30px;
    width: calc(100% + 60px);
    padding-right: 30px;
    padding-left: 30px;
  }
  .children > div {
    font-size: 1.25rem;
    line-height: 1.5625rem;
    font-weight: 500;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/Dropdown/Dropdown.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/repeatables/_box-shadow.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_clearfix.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AArMA;EIUI,6CAAA;EJRF,WAAA;EAEE,sBAAA;EAGA,mBAAA;AAoMJ;AA9LU;EACE,aAAA;AAgMZ;AAtLU;EACE,aAAA;AAwLZ;AAjLE;EACE,kBAAA;EAEE,gBAAA;AAkLN;AA9KM;EAEI,mBAAA;AA+KV;AAxKM;EACE,UAFE;AA4KV;AA3KM;EACE,UAFE;AA+KV;AA9KM;EACE,UAFE;AAkLV;AAjLM;EACE,UAFE;AAqLV;AApLM;EACE,UAFE;AAwLV;AAvLM;EACE,UAFE;AA2LV;AA1LM;EACE,UAFE;AA8LV;AA7LM;EACE,UAFE;AAiMV;AAhMM;EACE,UAFE;AAoMV;AA7LE;;EAEE,kBAAA;EACA,UAAA;EACA,WAAA;AA+LJ;AA5LE;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EAEE,qBAAA;EACA,mBAAA;EACA,kBAAA;AA6LN;AA3LI;EACE,WAAA;EACA,qBAAA;EACA,eAAA;EAEE,mBAAA;EAGA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EAGA,gBAAA;EACA,yBAAA;EAGA,qBAAA;EAGA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAoLR;AAjLM;EAEI,2IAAA;EACA,iBAAA;AAkLV;AA9KI;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EAEE,iBAAA;EACA,kBAAA;AA+KR;AA7KM;EACE,WAAA;EACA,YAAA;AA+KR;AA7KM;EACE,WAAA;EACA,YAAA;EACA,OAAA;EAEE,iBAAA;AA8KV;AA3KQ;EAEI,kBAAA;AA4KZ;AAxKM;EACE,WAAA;EACA,YAAA;EACA,QAAA;EAEE,gBAAA;EAGA,iBAAA;AAuKV;AAnKQ;EACE,WAAA;EAEE,gBAAA;AAoKZ;AAjKQ;EACE,WAAA;EACA,YAAA;AAmKV;AAjKQ;EACE,WAAA;EAEE,iBAAA;AAkKZ;AA/JQ;EACE,WAAA;EAEE,gBAAA;AAgKZ;AA7JQ;EACE,WAAA;EAEE,gBAAA;AA8JZ;AA3JQ;EACE,WAAA;EAEE,iBAAA;AA4JZ;AAxJM;EACE,QAAA;EAEE,iBAAA;EAEF,gCAAA;AAwJR;AAvJQ;EAEI,mBAAA;AAwJZ;AAjJE;EACE,aAAA;EACA,kBAAA;AAmJJ;AAhJI;EAEI,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AAiJR;AA5II;EAEE,WAAA;EAEE,yBAAA;EAGA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AA0IR;AKrWE;EACE,WAAA;EACA,WAAA;EACA,cAAA;ALuWJ;AA7IM;EAEI,yBAAA;AA8IV;AA5IQ;EACE,YAAA;AA8IV;AA3IM;EACE,aAAA;AA6IR;AAxIE;;;EAGE,6BAAA;AA0IJ;AAvIE;EAEI,wCAAA;AAwIN;AAnII;EAEI,qBAAA;AAoIR;AAlIM;EACE,0BAAA;AAoIR;AAjII;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;AAmIN;AA/HE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,wBAAA;EACA,YAAA;EACA,gBAAA;EAEE,mBAAA;EACA,kBAAA;EAGA,yBAAA;AA8HN;AA5HI;EACE,iBAAA;AA8HN;AA7HM;EACE,iBAAA;AA+HR;AA5HI;EACE,iBAAA;AA8HN;;ACzZI;EDmSE;IAEI,eAAA;IAGA,iBAAA;IACA,mBAAA;IACA,oBAAA;IACA,kBAAA;EAuHR;EApHI;IAEI,kBAAA;IACA,iBAAA;EAqHR;EAnHM;IACE,kBAAA;EAqHR;EAhHI;IAEI,iBAAA;IACA,mBAAA;IACA,oBAAA;IACA,kBAAA;EAiHR;EA9GI;IAEI,iBAAA;IACA,mBAAA;IACA,oBAAA;IACA,kBAAA;EA+GR;EA1GE;IACE,WAAA;IACA,aAAA;IACA,wBAAA;IAEE,mBAAA;IACA,kBAAA;EA2GN;EAtGE;IACE,kBAAA;IACA,sBAAA;IACA,gBAAA;EAwGJ;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","@charset \"UTF-8\";\n\n@import '../_Assets/scss/core';\n\n.srprs-dropdown {\n  @include box-shadow();\n  color: color(black);\n  background: {\n    color: color(white);\n  }\n  margin: {\n    bottom: 12px;\n  }\n  &.is-complete {\n    header {\n      .srprs-icon {\n        &:first-child {\n          circle {\n            fill: color(success);\n          }\n        }\n      }\n    }\n  }\n  &.is-warning {\n    header {\n      .srprs-icon {\n        &:first-child {\n          circle {\n            fill: color(error);\n          }\n        }\n      }\n    }\n  }\n\n  .is-condensed & {\n    position: relative;\n    margin: {\n      bottom: 0;\n    }\n\n    > input:checked {\n      & ~ div {\n        margin: {\n          bottom: 10px;\n        }\n      }\n    }\n\n    @for $a from 1 to 10 {\n      $b: 10 - $a;\n      &:nth-child(#{$a}) {\n        z-index: $b;\n      }\n    }\n  }\n\n  > input[type='radio'],\n  > input[type='checkbox'] {\n    position: absolute;\n    opacity: 0;\n    z-index: -1;\n  }\n\n  header {\n    width: 100%;\n    position: relative;\n    line-height: 0;\n    border: {\n      width: 0 0 1px;\n      style: solid;\n      color: color(white);\n    }\n    label {\n      width: 100%;\n      display: inline-block;\n      cursor: pointer;\n      font: {\n        size: 1.125rem;\n      }\n      padding: {\n        top: 18px;\n        right: 50px;\n        bottom: 18px;\n        left: 20px;\n      }\n      text: {\n        align: left;\n        transform: uppercase;\n      }\n      line: {\n        height: 1.625rem;\n      }\n      margin: {\n        top: 0px;\n        right: 0px;\n        bottom: 0px;\n        left: 0px;\n      }\n\n      strong {\n        font: {\n          family: font(heading);\n          weight: bold;\n        }\n      }\n    }\n    .srprs-icon {\n      display: inline-block;\n      position: absolute;\n      top: 50%;\n      bottom: auto;\n      margin: {\n        left: 20px;\n        right: 20px;\n      }\n      svg {\n        width: 100%;\n        height: auto;\n      }\n      &:first-child {\n        width: 22px;\n        height: 22px;\n        left: 0;\n        margin: {\n          top: -11px;\n        }\n\n        & + label {\n          padding: {\n            left: 54px;\n          }\n        }\n      }\n      &:last-child {\n        width: 12px;\n        height: 12px;\n        right: 0;\n        margin: {\n          top: -6px;\n        }\n        line: {\n          height: 16px;\n        }\n      }\n      &#payment {\n        &-ideal {\n          width: 37px;\n          margin: {\n            top: -9px;\n          }\n        }\n        &-mastercard {\n          width: 48px;\n          height: 28px;\n        }\n        &-visa {\n          width: 46px;\n          margin: {\n            top: -13px;\n          }\n        }\n        &-paypal {\n          width: 27px;\n          margin: {\n            top: -3px;\n          }\n        }\n        &-klarna {\n          width: 46px;\n          margin: {\n            top: -3px;\n          }\n        }\n        &-bancontact {\n          width: 50px;\n          margin: {\n            top: -15px;\n          }\n        }\n      }\n      &:first-child[id^='payment'] {\n        top: 50%;\n        margin: {\n          left: 50px;\n        }\n        transform: translate(-50%, -50%);\n        & + label {\n          padding: {\n            left: 100px;\n          }\n        }\n      }\n    }\n  }\n\n  > div {\n    max-height: 0;\n    overflow-y: hidden;\n\n    // Dropdown body\n    > div {\n      padding: {\n        top: 20px;\n        right: 20px;\n        bottom: 20px;\n        left: 20px;\n      }\n    }\n\n    // Dropdown footer\n    > footer {\n      @include clearfix;\n      width: 100%;\n      background: {\n        color: lighten(color(grey-light), 5%);\n      }\n      padding: {\n        top: 10px;\n        right: 20px;\n        bottom: 10px;\n        left: 20px;\n      }\n      .srprs-button {\n        text: {\n          transform: uppercase;\n        }\n        &:first-child:last-child {\n          float: right;\n        }\n      }\n      &:empty {\n        display: none;\n      }\n    }\n  }\n\n  > header label,\n  > header .srprs-icon:last-child,\n  > div {\n    transition: all 200ms ease 0s;\n  }\n\n  > input:not(:checked) ~ header label:hover {\n    box: {\n      shadow: 0 0 10px rgba(#000, 0.15);\n    }\n  }\n\n  > input:checked {\n    & ~ header {\n      border: {\n        color: color(grey-light);\n      }\n      .srprs-icon:last-child {\n        transform: rotate(-180deg);\n      }\n    }\n    & ~ div {\n      max-height: 1400px;\n      margin-bottom: 24px;\n      overflow-y: visible;\n    }\n  }\n  // We need a massive _shame.scss, actually ;-)\n  .footer-temp {\n    position: relative;\n    display: flex;\n    align-items: center;\n    left: -20px;\n    bottom: -20px;\n    width: calc(100% + 40px);\n    height: 80px;\n    min-height: 80px;\n    padding: {\n      right: 20px;\n      left: 20px;\n    }\n    background: {\n      color: color(grey-light);\n    }\n    span {\n      margin-left: auto;\n      & + .srprs-button {\n        margin-left: 15px;\n      }\n    }\n    .srprs-button {\n      margin-left: auto;\n    }\n  }\n}\n\n@include breakpoint(tablet-portrait) {\n  .srprs-dropdown {\n    > header {\n      label {\n        font: {\n          size: 16px;\n        }\n        padding: {\n          top: 28px;\n          right: 60px;\n          bottom: 28px;\n          left: 30px;\n        }\n      }\n      .srprs-icon {\n        margin: {\n          right: 30px;\n          left: 30px;\n        }\n        &:first-child + label {\n          padding-left: 70px;\n        }\n      }\n    }\n    > div {\n      > div {\n        padding: {\n          top: 30px;\n          right: 30px;\n          bottom: 30px;\n          left: 30px;\n        }\n      }\n      > footer {\n        padding: {\n          top: 14px;\n          right: 30px;\n          bottom: 14px;\n          left: 30px;\n        }\n      }\n    }\n    // We need a massive _shame.scss, actually ;-)\n    .footer-temp {\n      left: -30px;\n      bottom: -30px;\n      width: calc(100% + 60px);\n      padding: {\n        right: 30px;\n        left: 30px;\n      }\n    }\n  }\n  .children {\n    > div {\n      font-size: 1.25rem;\n      line-height: 1.5625rem;\n      font-weight: 500;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@charset \"UTF-8\";\n\n$box-shadow: map-deep-get($srprsreactwebsite-config, 'box-shadow');\n\n@mixin box-shadow(\n  $blur: map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n) {\n  @if map-has-key($box-shadow, $blur) {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', $blur)\n      0\n      rgba(color(black), 0.15);\n  } @else {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n      0\n      rgba(color(black), 0.15);\n  }\n}\n","@charset \"UTF-8\";\n\n@mixin clearfix {\n  &::after {\n    clear: both;\n    content: '';\n    display: table;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
